<template>
  <div>
    <div class="container">
      <el-page-header class="page-header" @back="goBack" content="处方笺"></el-page-header>
      <div v-if="loading" class="prescription-state">正在生成处方，请稍候…</div>
      <div v-else-if="errorMessage || !prescriptions.length" class="prescription-state">
        <p>{{errorMessage || '暂无可预览的处方'}}</p>
        <el-button v-if="$route.query.visitRecordId" type="primary" plain @click="loadPrescriptions">重新加载</el-button>
      </div>
      <div class="prescription-container" v-for="(item,index) in prescriptions" :key="index">
        <h2 v-if="item.fileType !== 'pdf'" style="width: 100%;">名称：{{item.name}}</h2>
        <pdf-prescription-preview v-if="item.fileType === 'pdf'" :src="item.imageUrl" :title="item.name" @print="print(index)"></pdf-prescription-preview>
        <div v-else :class="['print-div','img-print'+index]">
          <img class="prescription-image" :style="{ width: pdfStyle === 1 || item.checkStatus == '2' ? '827px' : '1080px' }" :src="item.imageUrl" :alt="item.name || '处方图片'"/>
        </div>
        <div v-show="item.checkStatus == '2'" style="display: flex;flex-direction: column;align-items: flex-start;justify-content: flex-start;width: 100%;margin-left: 260px;">
          <span style="color: black;font-size: 20px;margin-top: 20px;">*处方文件链接：{{item.imageUrl}}</span>
          <span style="color: red;font-size: 20px;margin-top: 20px;">*临床诊断：{{item.disease}}</span>
          <span style="color: red;font-size: 20px;margin-top: 20px;">*{{item.tips}}</span>
        </div>
        <div class="btn-container" style="margin-top: 30px;">
          <el-button v-if="item.fileType !== 'pdf'" class="btn-primary" round type="primary" @click="print(index)">打印处方</el-button>
          <el-button class="btn-primary" round type="success" @click="fulfillment(index)" v-if="item.status =='0'||item.status =='1'">{{item.status == 0?'统一配送':'配送详情'}}</el-button>
          <el-button class="btn-back" round @click="close">关闭窗口</el-button>
        </div>
        <div style="height: 2px;width: 100%; background-color: #dedede;"></div>
      </div>
    </div>
  </div>

</template>

<script>
  import PdfPrescriptionPreview from './PdfPrescriptionPreview.vue'
  export default {
    components: { PdfPrescriptionPreview },
    data() {
      return {
        prescriptions: [],
        loading: false,
        errorMessage: ''
      }
    },
    computed: {
      pdfStyle() {
        return String(this.$route.query.pdfStyle) === '1' ? 1 : 0
      }
    },
    created() {
      this.loadPrescriptions()
    },
    methods:{
      loadPrescriptions(){
        this.errorMessage = ''
        this.prescriptions = []
        const visitRecordId = this.$route.query.visitRecordId
        if (!visitRecordId) { // 自拟组方缓存入口
          try {
            const images = JSON.parse(sessionStorage.getItem('images'))
            this.prescriptions = Array.isArray(images) ? images : []
          } catch (err) {
            this.errorMessage = '处方缓存已失效，请返回重新生成'
          }
          return
        }
        this.loading = true
        this.wjtHttp.get(this, '/api/health/v3/prescription/image/' + encodeURIComponent(visitRecordId) + '/' + this.pdfStyle, {}, true, (res) => {
          this.loading = false
          const data = res.data
          if (data.code == 200) {
            this.prescriptions = Array.isArray(data.data) ? data.data : []
          } else {
            this.errorMessage = data.msg || '出方异常，请联系管理员'
          }
        }, () => {
          this.loading = false
          this.errorMessage = '处方加载失败，请检查网络后重试'
        })
      },
      goBack(){
        this.$router.go(-1)
      },
      close(){
        this.$router.replace('/')
      },
      print(index){
        const prescription = this.prescriptions[index]
        if (!prescription || !prescription.imageUrl) return
        if (prescription.fileType === 'pdf') {
          // 直接打开原 PDF，保留文档页尺寸和分页，避免跨域 iframe.print 被浏览器拦截。
          window.open(prescription.imageUrl, '_blank', 'noopener,noreferrer')
          this.$message({
            message: '请在新打开的 PDF 中点击打印；若未打开，请使用“打开原文件”链接',
            type: 'info',
            duration: 6000
          })
          return
        }
        const imgElement = document.querySelector(`.img-print${index} img`);
        if (!imgElement) return;
        if (!imgElement.naturalWidth || !imgElement.naturalHeight) {
          this.$message({ message: '处方图片尚未加载完成，请稍后重试', type: 'warning' })
          return
        }

        // 创建隐藏的iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.style.left = '-1000px';
        document.body.appendChild(iframe);

        // 计算A4尺寸（保留原有尺寸计算逻辑）
        const A4_WIDTH = 827;
        const A4_HEIGHT = 1169;
        const aspectRatio = imgElement.naturalWidth / imgElement.naturalHeight;

        let printWidth, printHeight;
        if (imgElement.naturalWidth / A4_WIDTH > imgElement.naturalHeight / A4_HEIGHT) {
          printWidth = A4_WIDTH;
          printHeight = printWidth / aspectRatio;
        } else {
          printHeight = A4_HEIGHT;
          printWidth = printHeight * aspectRatio;
        }

        // 构建打印内容
        const printContent = `
          <html>
            <head>
              <style>
                @page {
                  size: A4 auto;
                  margin: 1cm;
                }
                body {
                  margin: 0;
                  width: 100vw;
                  height: 100vh;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
                img {
                  max-width: 100%;
                  max-height: 100%;
                  object-fit: contain;
                  page-break-inside: avoid;
                  transform: translateZ(0);
                }
                /* 横向打印时撑满宽度 */
                @media (orientation: landscape) {
                  img {
                    max-width: 100% !important;  /* 强制横向撑满 */
                    max-height: 90%;             /* 保留顶部空间给页眉 */
                  }
                }
              </style>
            </head>
            <body>
              <img src="${imgElement.src}" alt="处方图片">
            </body>
          </html>
        `;

        // 写入内容并打印
        iframe.contentDocument.write(printContent);
        iframe.contentDocument.close();

        iframe.contentWindow.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        };
      },
      fulfillment(index){
        var prescription = this.prescriptions[index]
        if(prescription.status == 0){ //下 配送订单
          sessionStorage.setItem('prescription',JSON.stringify(prescription))
          this.$store.commit('updateFulfillmentConfirmData',{})
          this.$router.push({
            path:'/fulfillmentConfirm',
            query:{
              index:index
            }
          })
        }else{
          this.$router.push({
            path:'/fulfillmentOrder',
            query:{
              orderId:prescription.deliveryOrderId
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  .container{
      width: 1160px;
      max-width: calc(100% - 32px);
      margin: auto auto;
  }
  .page-header{
      width: 1080px;
      max-width: 100%;
      margin-top: 30px;
      color: #333333;
      font-size: 20px;
  }
  .page-header >>> div{
      color:#333333;
      font-size: 20px;
  }
  .prescription-container{
    width: 1100px;
    max-width: 100%;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .print-div{
    width: 1080px;
    height: auto;
    text-align: center;
  }
  .prescription-image{
    max-width: 100%;
    height: auto;
  }
  .prescription-state{
    padding: 60px 0;
    text-align: center;
    color: #606266;
  }
  .btn-container{
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .btn-primary{
    width: 150px;
    margin-right: 30px;
  }
  .btn-back{
    width: 150px;
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/kaifang/prescriptionImage.vue